document.addEventListener('DOMContentLoaded', function () {

    const menuItems = document.querySelectorAll(".header__menu-item--subitems");
    registerParentMenuItemEvents(menuItems);

});


function registerParentMenuItemEvents(menuItems){
    if(menuItems.length === 0) return;
    menuItems.forEach(menuItem => {
        menuItem.addEventListener("click", (e) => e.preventDefault());
    })
}